// extracted by mini-css-extract-plugin
module.exports = {"message":"Notification_message__294LW"};